// extracted by mini-css-extract-plugin
module.exports = {"saveForLaterButton":"BasketSummary_saveForLaterButton__i75K3","basketSummary":"BasketSummary_basketSummary__02c3m","freeDeliveryNotice":"BasketSummary_freeDeliveryNotice__nWQNU"};